module.exports = __webpack_public_path__ + "static/img/5.8d46001.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/5.png
// module id = ehV7
// module chunks = 0